import { render, staticRenderFns } from "./WorkRecycle.vue?vue&type=template&id=309a3ab5&scoped=true"
import script from "./WorkRecycle.vue?vue&type=script&lang=js"
export * from "./WorkRecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a3ab5",
  null
  
)

export default component.exports